import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Finance.ClaimJobPaymentItem.ProcessUsBankPayment.IRequest;
type Response = Api.Finance.ClaimJobPaymentItem.ProcessUsBankPayment.IResponse;
type Headers = Api.Finance.ClaimJobPaymentItem.ProcessUsBankPayment.IHeaders;
const url = '/api/Finance/ClaimJobPaymentItem/:id/ProcessUsBankPayment';
export default async function claimJobPaymentItemProcessUsBankPaymentApi(body?: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.post,
    url: createPathFromRoute(url, { id: body.claimJobPaymentItemId }),
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
